export default {
  pageHeader: "評価項目設定",
  memberTransferSetting: "人事異動設定",
  team: "チーム",
  personal: "個人",
  mission: "ミッション",
  goal: "部署･上司の目標",
  personalTransfer: "人事異動メンバー",
  listMember: "部・チームメンバー実績一覧",
  addMember: "部・チーム内のメンバー追加",
  transferMembers: "人事異動メンバー",
  evaluate: "評価項目",
  comment: {
    title: "コメント欄",
    overAll: "総合結果記入欄",
    boss: "評価期末　上司コメント",
    personal: "評価期末　本人コメント",
  },
  targetPeriod: "プロセス目標",
};
